<template>
  <v-card
    v-if="product"
    class="card--coin-product-promo"
    :class="{ clickable: clickable, selected: selectedProduct === product }"
    role="button"
    :tabindex="clickable ? 0 : -1"
    :aria-pressed="selectedProduct === product"
    @click="selectProduct"
    @keydown.enter.prevent="selectProduct"
    @keydown.space.prevent="selectProduct"
  >
    <div class="promo-card__visual">
      <div class="promo-card__visual-frame">
        <img class="promo-card__background" :src="cardBackground" alt="" />
        <img class="promo-card__ribbon" :src="flagIndonesia" alt="" />
        <img class="promo-card__coin" :src="coinBackground" alt="" />
        <div class="promo-card__coin-copy" aria-hidden="true">
          <strong>{{ product.qty }}</strong>
          <span>{{ $t('product.coinSlot') }}</span>
        </div>
      </div>
      <img v-if="product.bonus_qty" class="promo-card__label" :src="labelPromo" alt="" />
    </div>

    <div class="promo-card__price">
      <div v-if="product.discount_price" class="promo-card__price-group">
        <div class="promo-card__price-before">
          {{ $n(product.price, 'currency', 'id-ID') }}
        </div>
        <div class="promo-card__price-after">
          {{ $n(product.price - product.discount_price, 'currency', 'id-ID') }}
        </div>
      </div>
      <div v-else class="promo-card__price-after">
        {{ $n(product.price, 'currency', 'id-ID') }}
      </div>
    </div>

    <div v-if="product.bonus_qty" class="promo-card__bonus">
      <v-icon class="promo-card__bonus-icon" aria-hidden="true">mdi-gift</v-icon>
      <span>{{ `Free ${product.bonus_qty} koin` }}</span>
    </div>

    <div class="promo-card__duration">
      <span>{{ `${product.duration} hari` }}</span>
    </div>
  </v-card>
</template>

<script>
import cardBackground from '@/assets/img/promo-merdeka/card-background.png';
import coinBackground from '@/assets/img/promo-merdeka/coin-background.png';
import flagIndonesia from '@/assets/img/promo-merdeka/flag-indonesia.png';
import labelPromo from '@/assets/img/promo-merdeka/label-promo.png';

export default {
  name: 'CardCoinProductPromo',
  props: {
    product: {
      default: null,
      required: true,
    },
    clickable: {
      default: false,
    },
  },
  data() {
    return {
      cardBackground,
      coinBackground,
      flagIndonesia,
      labelPromo,
    };
  },
  computed: {
    selectedProduct: {
      get() {
        return this.$store.state.product.selectedProduct;
      },
      set(val) {
        this.$store.commit('product/SET_SELECTED_PRODUCT', val);
      },
    },
  },
  methods: {
    selectProduct() {
      this.selectedProduct = this.product;
    },
  },
};
</script>
